const businessData = {
  user_id: "",
  email: "",
  name: "",
  contact_phone: "",
  radius: null,
  serialized_job_filter_data: null,

  job_filter: {
    category: "",
    category_id: null,
    suburb: "",
    suburb_id: null
  }
}

export default businessData
